import { ReactNode } from 'react';
import { Element } from 'domhandler';
import parse, { DOMNode, domToReact, HTMLReactParserOptions } from 'html-react-parser';

import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';

const isElement = (node: DOMNode): node is Element => 'name' in node && 'attribs' in node;

export const convertHtmlToReactElement = (
  html: string,
  tagsToReplace: string[] = ['a', 'p'],
): ReactNode => {
  const options: HTMLReactParserOptions = {
    replace: domNode => {
      if (!isElement(domNode)) {
        return undefined;
      }
      if (!tagsToReplace.includes(domNode.name)) {
        return undefined;
      }

      switch (domNode.name) {
        case 'a':
          return (
            <ExternalLink target="_blank" href={domNode.attribs.href ?? ''} className="underline">
              {domToReact(domNode.children as DOMNode[], options) as ReactNode}
            </ExternalLink>
          );
        case 'p':
          return <>{domToReact(domNode.children as DOMNode[], options) as ReactNode}</>;
        default:
          return undefined;
      }
    },
  };

  return parse(html, options) as ReactNode;
};
